import { useTranslation } from 'react-i18next';
import GridContainer from 'components/Grid/GridContainer';
import makeStyles from '@material-ui/styles/makeStyles';

import FormTextInput from '../../../components/FormTextInput/FormTextInput';
import GridItem from '../../../components/Grid/GridItem';

const useStyles = makeStyles({
  title: {
    marginLeft: '15px',
  },
});

const PayPoModule = ({ module, handleModuleUpdate }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <GridContainer>
        <GridItem xs={12}>
          <h3 className={classes.title}>{t('paymentType.title.PayPo')}</h3>
        </GridItem>
      </GridContainer>
      <GridItem xs={4}>
        <FormTextInput
          label={t('brandCfg.securityUrl')}
          name="payPoUrl"
          value={module.url}
          handleChange={e => {
            handleModuleUpdate({
              ...module,
              url: e.target.value,
            });
          }}
          inputSize={12}
        />
      </GridItem>
      <GridItem xs={4}>
        <FormTextInput
          label={t('paymentType.payPoId')}
          name="payPoId"
          value={module.merchantId}
          handleChange={e => {
            handleModuleUpdate({
              ...module,
              merchantId: e.target.value,
            });
          }}
          inputSize={12}
        />
      </GridItem>
      <GridItem xs={4}>
        <FormTextInput
          label={t('brandCfg.securityCode')}
          name="payPoToken"
          value={module.token}
          handleChange={e => {
            handleModuleUpdate({
              ...module,
              token: e.target.value,
            });
          }}
          inputSize={12}
        />
      </GridItem>
    </>
  );
};

export default PayPoModule;
